module.exports = __webpack_public_path__ + "img/oomiya.af01a6c3.jpg";